<template>
    <div class="tabs">
        <div class="tabs-name">
            <div class="tabs_button">
                <button 
                    v-for="item in tabs" 
                    :key="item" 
                    @click="$emit('click',item)"
                    :class="item == value?'active':''"
                    >{{item}}</button>
            </div>
            <div class="tabs_panel">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
export default{
    props:['tabs','value'],
    emits:['click'],
}
</script>
<style>
.tabs{
    margin-top: 10px;
}
.tabs_button{
    display: flex;
    gap: 10px;
}
.tabs_button button{
    box-sizing: border-box;
    border: solid 2px #175472;
    border-bottom: none;
    color: #0D3041;
    border-radius: 10px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    background-color: var(--background);
    font-weight: 401;
    font-size: 14px;
    cursor: pointer;
    line-height: 130%;
    font-family: Rubik;
    padding: 5px;
}
.tabs_button button:active,
.tabs_button button.active{
    background-color: #174E72;
    color: #FFF;
}  
.tabs_button button:hover{
    background-color: #EDF6FF;
}

</style>